import { render, staticRenderFns } from "./CompleteTariffing.vue?vue&type=template&id=d56104b2&scoped=true"
import script from "./CompleteTariffing.vue?vue&type=script&lang=js"
export * from "./CompleteTariffing.vue?vue&type=script&lang=js"
import style0 from "./CompleteTariffing.vue?vue&type=style&index=0&id=d56104b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56104b2",
  null
  
)

export default component.exports